import util from '@bmp-vue/core/api/util'
const controller = 'CreditoSimples'
export default Object.assign({}, util.GetCrud(controller, ['none']), {
})
